import React from 'react';
import { isMobile } from 'react-device-detect';
import { Event, RTL_LANGUAGES } from './types';
import { CloseIcon } from './icons/Close';
import { sendChatEvent } from './eventHandlers';
export var ChatPreview = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var direction = 'ltr';
    if (props.partnerConfig.defaultLanguageCode) {
        direction = RTL_LANGUAGES.includes(props.partnerConfig.defaultLanguageCode) ? 'rtl' : 'ltr';
    }
    var flexLeft = !!((_a = props.partnerConfig.containerStyle) === null || _a === void 0 ? void 0 : _a.left);
    var previewStyle = {
        maxWidth: isMobile ? 280 : 350,
        maxHeight: 700,
        marginTop: 'auto',
        boxSizing: 'border-box',
        userSelect: 'none',
        zIndex: 2147483647,
        pointerEvents: 'auto',
        alignItems: 'center',
        position: 'relative',
        direction: 'ltr',
        color: (_b = props.partnerConfig.colors) === null || _b === void 0 ? void 0 : _b.text
    };
    var previewTextStyle = {
        maxWidth: isMobile ? 280 : 350,
        maxHeight: 700,
        marginTop: 'auto',
        marginLeft: flexLeft ? undefined : 32,
        border: '1px solid #E6EAF2',
        boxSizing: 'border-box',
        filter: 'drop-shadow(0px 5px 100px rgba(35, 31, 32, 0.3))',
        borderRadius: ((_c = props.partnerConfig.borderRadius) === null || _c === void 0 ? void 0 : _c.widget) || 10,
        userSelect: 'none',
        zIndex: 2147483647,
        pointerEvents: 'auto',
        background: '#FFFFFF',
        fontFamily: props.fontName,
        fontSize: '18px',
        lineHeight: '21px',
        alignItems: 'center',
        padding: '12px',
        cursor: 'pointer',
        direction: direction,
        color: (_d = props.partnerConfig.colors) === null || _d === void 0 ? void 0 : _d.text
    };
    var previewTitle = ((_e = props.partnerConfig.preview) === null || _e === void 0 ? void 0 : _e.message) || 'Hi! Can I help plan your next trip?';
    return (React.createElement("div", { style: previewStyle },
        React.createElement("div", { onClick: props.onClose, style: {
                top: 0,
                position: 'absolute',
                padding: 7,
                background: '#FFFFFF',
                boxShadow: '0px 1px 3px rgba(35, 31, 32, 0.2)',
                borderRadius: 4,
                cursor: 'pointer',
                lineHeight: 0,
                right: flexLeft ? '-35px' : undefined
            } },
            React.createElement(CloseIcon, { color: (_g = (_f = props.partnerConfig) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.icon })),
        React.createElement("div", { onClick: function () {
                var event = {
                    type: Event.CLICKED_ON_PREVIEW,
                    button_title: previewTitle
                };
                sendChatEvent(event);
                props.onPreviewClick();
            }, style: previewTextStyle }, previewTitle)));
};
